import styled from 'styled-components';


export const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  position: relative;
  overflow-y: auto;
  padding: 24px 24px 80px 100px;


  @media (max-width: 1024px) {
    padding: 20px 20px 60px 60px;
  }

  @media (max-width: 768px) {
    padding: 16px 16px 40px 40px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100vh;
  width: 100%;
  background-color: ${props => props.showPopup ? 'rgba(0, 0, 0, 0.4)' : 'rgba(241, 230, 252, 1.0)'};
  font-family: var(--font-family-ibm_plex_sans);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000;
  overflow: hidden;

 
  @media (max-width: 765px) {
    display: none;
  }

  /* First child = the inert wrapper around the embedded Header (see
     OnboardingComplete.jsx). The header above the checklist is context, not
     controls — \`inert\` on the wrapper blocks keyboard focus + pointer;
     the pointer-events rule is belt-and-braces (universal selector because
     pointer-events doesn't inherit past explicit descendant values — same
     pattern as the tour click-lock in globals.css). */
  & > div:first-child,
  & > div:first-child * {
    pointer-events: none;
  }

  & > div:first-child {
    width: 100% !important;
  }

  /* The Header's own sticky root (was first-child before the inert wrapper
     was introduced; selectors below shifted one level deeper with it). */
  & > div:first-child > div {
    z-index: 2005 !important;
    left: 0 !important;
    width: 100% !important;
  }

  & > div:first-child > div > div {
    left: 0 !important;
    margin-left: 0px !important;
    padding-left: 100px !important;

    @media (max-width: 1024px) {
      margin-left: 40px !important;
      padding-left: 40px !important;
    }

    @media (max-width: 766px) {
      margin-left: 20px !important;
      padding-left: 20px !important;
    }
  }
`;

export const ModalContainer = styled.div`
  max-width: 1450px;
  width: 95%;
  min-height: 1105px;
  background-color: white;
  border-radius: 14px;
  position: relative;
  padding: 40px 50px;
  margin: 20px auto 0 auto;
  gap:8px;  
  box-shadow: 0px 4px 30.2px 0px #B199CE40;



  display: flex;
  flex-direction: column;

  @media (max-width: 1024px) {
    width: 85%;
    padding: 32px;
    margin: 30px auto 0 100px;
    gap:3px;
    height:100%;
  }

  @media (max-width: 768px) {
    padding: 24px;
    margin: 20px auto 0 100px; 
  }
`;

export const InnerWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`;


export const HeaderWrapper = styled.div`
  position: relative;
  display: flex;
  max-width: 1346px;
  width: 100%;
  flex-direction: row;
  align-items: center;
  margin-top:5px;
  gap: 10px;
  padding: 0 20px;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    width: 100%;
    padding: 0 16px;
  }

  @media (max-width: 768px) {
    padding: 0 12px;
  }
`;
 
export const CloseIcon = styled.img`
  position: absolute;
  // top: 20px;
  right: 10px;
  cursor: pointer;
  width: 36px;
  height: 36px;

  @media (max-width: 1024px) {
    right: 16px;
  }

  @media (max-width: 768px) {
    width: 28px;
    height: 28px;
    top: 16px;
    right: 12px;
  }
`;

export const ProgressContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  gap: 8px;

  @media (max-width: 1024px) {
    padding: 0 16px;
  }

  @media (max-width: 768px) {
    padding: 0 12px;
  }

  @media (max-width: 768px) {
    margin-top: 16px;
    flex-direction: column;
  }
     @media (max-width: 1024px) {
    margin-top: 12px;
    flex-direction: column;
  }
`;

export const Title = styled.div`
  font-family: 'IBM Plex Sans';
  font-weight: 700;
  font-size: 32px;
  line-height: 1.9; 
  letter-spacing: 0%;

  @media (max-width: 1024px) {
    font-size: 28px;
    line-height: 1.8;
  }

  @media (max-width: 768px) {
    font-size: 24px;
    line-height: 1.7;
  }
`;

export const SectionTitle = styled.div`
  font-family: 'IBM Plex Sans';
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
`;

export const PersonaliseTitle = styled.div`
  font-family: 'IBM Plex Sans', sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 40px;
  letter-spacing: 0%;
`;

export const SubText = styled.div`
  font-family: 'IBM Plex Sans';
  font-weight: 600;
  font-size: 20px;
  line-height: 33px;
  text-align: left;
  letter-spacing: 0%;

  @media (max-width: 1024px) {
    font-size: 16px;
    line-height: 1.6;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 1.5;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0 20px 20px 20px;

  @media (max-width: 1024px) {
    gap: 16px;
    padding: 0 16px 16px 16px;
  }

  @media (max-width: 768px) {
    gap: 12px;
    padding: 0 12px 12px 12px;
  }
`;
